import React from 'react';
import BodyItem from './BodyItem';
import text from '../../text';
import routes from '../../routes/constants';
var ConnectSection = function() {
    return /*#__PURE__*/ React.createElement(BodyItem, {
        className: "ConnectSection",
        title: text('connect')
    }, /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiWebsiteUrl.contactUs,
        rel: "noreferrer",
        target: "_blank"
    }, text('contactUs')), /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiWebsiteUrl.survey,
        rel: "noreferrer",
        target: "_blank"
    }, text('leaveReview')), /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiWebsiteUrl.blog,
        rel: "noreferrer",
        target: "_blank"
    }, text('blog')));
};
export default ConnectSection;
